import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { useIntl } from 'react-intl';
import { FACILITIES_NEARBY_LIMIT } from '../../constants/facilitiesNearby';
import useQuery from '../../modules/react/hooks/useQuery';
import FacilitiesMapWithLegend, { FacilitiesMapWithLegendLoading } from '../components/stateful/FacilitiesMapWithLegend';
import FacilitiesMapWithLegendPrimaryFacility from './FacilitiesMapWithLegendPrimaryFacility';

const GET_CURRENT_USER = gql`
  query GetFacilitiesNearbyCurrentUserMapWithLegendData($coordinates: [Float!], $limit: Int!, $live: Boolean!, $locale: String!) {
    currentUser {
      facilitiesNearby(filter: { coordinatesOverride: $coordinates, limit: $limit, live: $live, locale: $locale }) {
        id
        ...FacilitiesMapWithLegendFacility
      }
    }
  }

  ${FacilitiesMapWithLegend.fragments.facility}
`;

const propTypes = {
  primaryFacilityId: PropTypes.string,
  ssr: PropTypes.bool,
  title: PropTypes.string,
};

const defaultProps = {
  primaryFacilityId: undefined,
  ssr: undefined,
  title: undefined,
};

const FacilitiesNearbyCurrentUserMapWithLegend = ({
  primaryFacilityId,
  ssr,
  title,
  ...rest
}) => {
  const { locale } = useIntl();
  const [coordinates, setCoordinates] = useState(null);

  useEffect(() => {
    if (window && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition((pos) => {
        const { longitude, latitude } = pos.coords;
        setCoordinates([longitude, latitude]);
      });
    }
  }, []);

  const { data, loading } = useQuery(GET_CURRENT_USER, {
    ssr: false,
    variables: { coordinates, limit: FACILITIES_NEARBY_LIMIT, live: true, locale },
  });

  const loadingIndicator = (
    <FacilitiesMapWithLegendLoading
      title={title}
      legendItemDisplayCount={FACILITIES_NEARBY_LIMIT}
    />
  );

  if (loading) {
    return loadingIndicator;
  }

  if (!data) {
    return null;
  }

  const { currentUser } = data;

  return (
    <FacilitiesMapWithLegendPrimaryFacility
      primaryFacilityId={primaryFacilityId}
      facilities={currentUser.facilitiesNearby}
    >
      {facilities => (
        <FacilitiesMapWithLegend
          {...rest}
          facilities={facilities}
          primaryFacilityId={primaryFacilityId}
          title={title}
        />
      )}
    </FacilitiesMapWithLegendPrimaryFacility>
  );
};

FacilitiesNearbyCurrentUserMapWithLegend.propTypes = propTypes;
FacilitiesNearbyCurrentUserMapWithLegend.defaultProps = defaultProps;

export default FacilitiesNearbyCurrentUserMapWithLegend;
